import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * Result object returned by InsertQueryBuilder execution.
 */
export var InsertResult = /*#__PURE__*/function () {
  function InsertResult() {
    _classCallCheck(this, InsertResult);
    /**
     * Contains inserted entity id.
     * Has entity-like structure (not just column database name and values).
     */
    this.identifiers = [];
    /**
     * Generated values returned by a database.
     * Has entity-like structure (not just column database name and values).
     */
    this.generatedMaps = [];
  }
  _createClass(InsertResult, null, [{
    key: "from",
    value: function from(queryResult) {
      var result = new this();
      result.raw = queryResult.raw;
      return result;
    }
  }]);
  return InsertResult;
}();